module.exports = __webpack_public_path__ + "img/certificate03-1-2.76b5b5fd.jpg";